import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { IconAlertCircle } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, TextField, Tooltip } from '@rossum/ui/material';

type RenderControlledTextInputProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  control: Control<TFieldValues>;
  schemaId: Path<TFieldValues>;
  errorMessage?: string;
  className?: string;
};
export const RenderControlledTextInput = <
  TFieldValues extends FieldValues = FieldValues,
>({
  control,
  errorMessage,
  schemaId,
  className,
}: RenderControlledTextInputProps<TFieldValues>) => {
  return (
    <Stack sx={{ height: 1, justifyContent: 'center' }}>
      <Controller
        control={control}
        name={schemaId}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            sx={{
              // if the field is not focused and the input is empty, hide the field
              '&:not(:focus-within):has(input:placeholder-shown)': {
                display: errorMessage ? 'block' : 'none',
              },
            }}
            className={className}
            size="small"
            placeholder=""
            color={errorMessage ? 'error' : 'primary'}
            slotProps={{
              htmlInput: {
                'data-cy': `custom-precision-field-${schemaId}`,
              },
              input: {
                // when pressing cmd + a the selection should stay within the input element
                onKeyDown: e => e.stopPropagation(),
                endAdornment: errorMessage ? (
                  <Tooltip title={errorMessage}>
                    <SvgIcon fontSize="medium" color="error">
                      <IconAlertCircle />
                    </SvgIcon>
                  </Tooltip>
                ) : null,
              },
            }}
          />
        )}
      />
    </Stack>
  );
};
